import { FormTemplate, Project, ProjectForResolver, UserForResolver } from "../db/definitions";

const filterTemplatesByGroupAndProject = (
	templates: FormTemplate[],
	groupFilter: boolean,
	projectFilter: boolean,
	user: UserForResolver,
	project: Pick<Project, "id"> & Partial<Project>,
	allowProjectScopedGroupTemplates = false,
) => {
	const filteredList = templates.filter((template) => {
		if (groupFilter && template.group !== user.group) {
			return false;
		} else if (!allowProjectScopedGroupTemplates && groupFilter && template.projectId && template.projectId !== "") {
			return false;
		}

		// Needs to be based on projectId not sync config
		if (projectFilter && template.projectId !== project.id) {
			return false;
		}

		return true;
	});

	return filteredList;
};

export default filterTemplatesByGroupAndProject;
